import { render } from "./ReservationFailPage.vue?vue&type=template&id=4fc42ba6"
import script from "./ReservationFailPage.vue?vue&type=script&lang=js"
export * from "./ReservationFailPage.vue?vue&type=script&lang=js"

import "./ReservationFailPage.vue?vue&type=style&index=0&id=4fc42ba6&lang=scss"

import exportComponent from "/Volumes/Samsung_T5/Work/Projects/my_projects/profiguide/profiguide/src/profiguide/static/web_plugin/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__